export default __webpack_public_path__ + "static/media/browser_app_icon_modal.fb15f74d.svg";